export const AUTH_CODE = {
    contentManagement: {
        create: "MA01",
        editUpdate: "MA02",
        listing: "MA04",
        delete: "MA10",
        transcoding: "MA07"
    },

    defination: {
        getIdDefination: "MA08"
    },
    userRole: {
        userRoleSetting: "TA15"
    },
    userTracker: {
        trPanelLogs: "TR02"
    },
    user: {
        activateDeactivate: "TA08",
        editUpdate: "TA06",
        create: "TA05",
        listing: "TA13"
    },

    accountGamMetrics: {
        createGamMetrics: "PU01",
        edit_UpdateGamMetrics: "PU03"
    },

    accounts: {
        createPublisher: "PU04",
        editUpdatePublisher: "PU06",
        publisherInfo: "PU05",
        publisherListing: "PU07",
        activateDeactivatePublisher: "PU10",
        accountByUserId: "PU98", // default api
        updatePassword: "PU70", // UI Permission 
    },

    adPlacementConf: {
        adPlacementConfiguration: "PU11",
        uploadExclusionUrl: "PU12",
        deleteExclusionUrl: "PU13",
        downloadExclusionUrl: "PU66"
    },

    adPlacement: {
        createAdPlacement: "PU14",
        editUpdateAdPlacement: "PU17",
        adPlacementListing: "PU16",
        makeDuplicateAdPlacement: "PU18",
        generateAmpTags: "PU19",
        activateDeactivateAdPlacement: "PU21"
    },

    demandPartner: {
        gamSettingListing: "PU22",
        getGamSettingById: "PU23", // default api
        editUpdateGamSetting: "PU25",
        editUpdatePageViews: "PU27",
        inclusionExclusionAdUnit: "PU28",
        gamViewMappingList: "PU26", // default api
        renameAdUnits: "PU29"
    },

    financeInvoice: {
        createInvoice: "PU30",
        editUpdateInvoice: "PU32",
        downloadPaymentAdvice: "PU34",
        invoiceRecentActivity: "PU60",
        downloadInvoice: "PU61",
        sendReminder: "PU62",
        invoiceListing: "PU67"
    },

    gamMetrics: {
        gamMetricsList: "PU35"
    },

    gamReporting: {
        gamReport: "PU36"
    },

    gamSetting: {
        createUpdateGamSetting: "PU37"
    },

    instreamAdSetup: {
        createInstreamAd: "PU41",
        updateInstreamAd: "PU43",
        instreamListing: "PU44",
        deleteInstreamSetting: "PU63"
    },

    instreamTagSetting: {
        createSetting: "PU45",
        manageInstreamSetting: "PU47",
        edit_UpdateInstreamSetting: "PU48",
        scheduleInstream: "PU57",
        instreamScheduleSettings: "PU58",
        deleteInstreamScheduleSetting: "PU59",
        generateInstreamTag: "PU49" // default api
    },

    publisherInvoice: {
        invoiceListing: "PU52",
        uploadInvoice: "PU53",
        publishDraftInvoice: "PU54",
        downloadInvoice: "PU55"
    },

    invoiceSetting: {
        invoiceListing: "PU51", // default api
        createUpdateInvoiceSetting: "PU50",
        approveInvoiceSetting: "PU69" // UI Permission
    },
    userSecurity: {
        viewDashboard: "SE01"
    }
};

